import {ValueEditorLocalizationManager} from '../localizations/value-editor-localization.manager';
import type {ValueEditorLocalizations} from '../localizations/types';

export class ErrorMessagesLocalizationService extends ValueEditorLocalizationManager<ValueEditorErrorMessagesLocalizations>{
    public static serviceName = 'errorMessagesLocalizationService';

    /*@ngInject*/
    constructor(valueEditorDefaultErrorMessagesLocalizations: Readonly<ValueEditorErrorMessagesLocalizations>) {
        super(valueEditorDefaultErrorMessagesLocalizations);
    }
}


/**
 * @ngdoc type
 * @name ValueEditorErrorMessagesLocalizations
 * @module portaro.value-editors.error-messages
 *
 * @property {string} required
 * @property {string} minlength
 * @property {string} maxlength
 * @property {string} pattern
 * @property {string} number
 * @property {string} min
 * @property {string} max
 * @property {string} fromBiggerThanTo
 * @property {string} toBiggerThanFrom
 * @property {string} minDate
 * @property {string} maxDate
 * @property {string} 'list-required'
 * @property {string} 'max-count'
 * @property {string} 'passwords-equals'
 * @property {string}  email
 * @property {string}  url
 * @property {string}  notBlank
 *
 * @description
 * Default localizations: {@link valueEditorDefaultErrorMessagesLocalizations}
 */
export interface ValueEditorErrorMessagesLocalizations extends ValueEditorLocalizations {
    required: string;
    async: string;
    minlength: string;
    maxlength: string;
    pattern: string;
    // eslint-disable-next-line id-blacklist
    number: string;
    date: string;
    min: string;
    max: string;
    fromBiggerThanTo: string;
    toBiggerThanFrom: string;
    minDate: string;
    maxDate: string;
    'list-required': string;
    'max-count': string;
    'passwords-equals': string;
    email: string;
    url: string;
    notBlank: string;
}

/**
 * @ngdoc constant
 * @name valueEditorDefaultErrorMessagesLocalizations
 * @module portaro.value-editors.error-messages
 *
 * @description
 * ```
 * {
 *  required: 'This field is required',
 *  async: 'Error',
 *  minlength: 'Too short',
 *  maxlength: 'Too long',
 *  pattern: 'Input does not match pattern',
 *  number: 'Value is not a number',
 *  min: 'Too low',
 *  max: 'Too high',
 *  fromBiggerThanTo: 'From is higher than to',
 *  toBiggerThanFrom: 'To is higher than from',
 *  minDate: 'Date is too in past',
 *  maxDate: 'Date is too in future',
 *  'list-required': 'List cannot be empty',
 *  'max-count': 'Too many items',
 *  'passwords-equals': 'Passwords do not match',
 *  email: 'Not a valid e-mail address',
 *  url: 'Not a valid URL',
 *  notBlank: 'Input can not have only blank characters'
 * }
 * ```
 */
export const VALUE_EDITOR_DEFAULT_ERROR_MESSAGES_LOCALIZATIONS: Readonly<ValueEditorErrorMessagesLocalizations> = Object.freeze({
    required: 'This field is required',
    async: 'Error',
    minlength: 'Too short',
    maxlength: 'Too long',
    pattern: 'Input does not match pattern',
    // eslint-disable-next-line id-blacklist
    number: 'Value is not a number',
    date: 'Date has invalid format',
    min: 'Too low',
    max: 'Too high',
    fromBiggerThanTo: 'From is higher than to',
    toBiggerThanFrom: 'To is higher than from',
    minDate: 'Date is too in past',
    maxDate: 'Date is too in future',
    'list-required': 'List cannot be empty',
    'max-count': 'Too many items',
    'passwords-equals': 'Passwords do not match',
    email: 'Not a valid e-mail address',
    url: 'Not a valid URL',
    notBlank: 'Input can not have only blank characters'
});